export const NAVIGATOR_STATE = {
  DONE: 'done',
  ACTIVE: 'active',
  NONE: 'none',
};

export const TABS = {
  WORKATO: 'workato',
  MEDALIA: 'medalia',
};

export const MOMENT_LANGUAGE = {
  'da-DK': 'da', // Danish
  'de-DE': 'de', // German
  'en-US': 'en', // English
  'es-ES': 'es', // Spanish
  'fi-FI': 'fi', // Finnish
  'fr-FR': 'fr', // French
  'it-IT': 'it', // Italian
  'ja-JP': 'ja', // Japanese
  'ko-KR': 'ko', // Korean
  'pt-BR': 'pt-br', // Portuguese (Brazil)
  'ro-RO': 'ro', // Romanian,
  'ru-RU': 'ru', // Russian
  'tr-TR': 'tr', // Turkish
  'zh-CN': 'zh-cn', // Chinese (PRC)
};

export const LD_ZONES_CLIENTIDS = {
  z0: '64d3544690dd0713746b014e',
  z1: '64d3544690dd0713746b0150',
  z2: '64d3544690dd0713746b014c',
  z3: '64d3544690dd0713746b014a',
  'z1-a': '64d3544690dd0713746b0146',
};

export const FEATURE_FLAGS = {
  SHOW_WIDGETS_TAB: 'ihub-widgets-tab',
  MEDALLIA_SURVEY_INTERACTIVENESS: 'medallia-survey-interactiveness',
  WORKATO_PRIVATE_COMMUNITY_LIBRARY: 'ihub-workato-private-community-library',
  SHOW_AUTOSEARCH_SWITCH: 'ihub-autosearch-switch',
  SHOW_PREPOPULATE_FIELDS: 'ihub-salesforce-widget-pre-populate',
  AUTOSYNC: 'ihub-salesforce-widget-automatic-sync',
  SHOW_DEFAULT_OVERRIDE: 'ihub-salesforce-wizard-default-override',

};

export const CSDS_KEYS = {
  MEDALLIA_ADAPTOR: 'ihubMedalliaAdaptor',
  WORKATO_INTEGRATION: 'ihubWorkatoIntegration',
  SHELL: 'ihubShell',
  CRMW_CONFIG: 'ihubCrmwConfig',
  CRMW_DATA: 'ihubCrmwData',
  CRMW_EXPLORER: 'ihubCrmwExplorer',
};

export const NAMESPACE = {
  IHUB: 'IHub',
};

export const SITE_SETTINGS_CONTEXT_TYPES = {
  USER: 'USER',
};

export const WORKATO_PLATFORM_DOMAIN = 'workatoPlatform';
export const WORKATO_EMBEDDED_DOMAIN = 'workatoEmbeddedDomain';
export const IHUB_CONFIG = 'ihubConfig';
export const WORKATO_CONFIG_NAME = 'configName';

export const IHUB_SHELL_PLATFORM_DOMAIN = 'ihubshellPlatform';

export const MEDALLIA_PLATFORM_DOMAIN = 'medalliaPlatform';
export const MEDALLIA_SKILL_ID_FIELD = 'skillId';
export const MEDALLIA_SURVEY_ID_FIELD = 'surveyId';

export const WIDGET_CONFIG_DOMAIN = 'widgetConfig';
export const WIDGET_EXPLORER_DOMAIN = 'widgetExplorer';
export const WIDGET_DATA_DOMAIN = 'widgetData';

export const WIDGET_AC_DEFAULT_NAME = 'SalesForce Widget';
export const WIDGET_AC_COMPONENT_NAME = 'AWModuleWidget.SalesForceWidget';
export const WIDGET_AC_COMPONENT_PATH = 'p/AWModuleWidget.SalesForceWidget/latest/AWModuleWidget.SalesForceWidget.umd.js';

export const WIDGET_VIEW_ID = 'viewId';
export const WIDGET_LAYOUT_ID = 'layoutId';
export const WIDGET_EXPLORE_OBJECT = 'exploreObject';
export const WIDGET_EXPLORE_FIELD = 'exploreField';
export const WIDGET_SEARCH_PHRASE = 'searchPhrase';
export const WIDGET_TOS_ID = 'id';

export const SOURCE_APP_NAME = 'IHUB';

export const WORKATO_TIMEOUT_ERROR_CODE = 440;

export const MEDALLIA_TIMEOUT_ERROR_CODE = 440;

export const PREMADE_RECIPE_ICON = {
  SHOPIFY: 'shopify',
  SYSTRAN: 'systran',
  SALESFORCE: 'salesforce',
  QUICKBOOKS: 'quickbooks',
  SERVICENOW: 'service_now',
  BIGCOMMERCE: 'new_connector_2_connector_211827_1647974599',
};

export const PREMADE_RECIPE_TITLE = {
  LEAD_GENERATION: 'Welcome message after lead generation',
  SHOPIFY_UPDATE: 'Order status updates for Shopify orders',
  SERVICENOW_UPDATE: 'Status updates for ServiceNow incidents',
  PAYMENT_REMAINDERS: 'Payment reminders',
  BIGCOMMERCE_UPDATE: 'Order status updates for BigCommerce orders',
  CART_ABANDONMENT: 'Cart abandonment reminders',
};

export const WORKATO_DOMAIN_PREFIX_PLACEHOLDER = '{workatoEmbeddedDomain}';

export const WORKATO_NAVBAR_ROUTE = {
  RECIPE: '{workatoEmbeddedDomain}/recipes',
  DASHBOARD: '{workatoEmbeddedDomain}/dashboard/main',
  COMMUNITY_LIBRARY: '{workatoEmbeddedDomain}/browse/recipes',
  NEW_RECIPE: '{workatoEmbeddedDomain}/recipes/new',
  COMMON_DATA_MODELS: '{workatoEmbeddedDomain}/workato_schemas',
  CONNECTOR_SDK: '{workatoEmbeddedDomain}/custom_adapters',
  LOOKUP_TABLES: '{workatoEmbeddedDomain}/lookup_tables',
  MESSAGE_TEMPLATES: '{workatoEmbeddedDomain}/workato_templates',
  PEOPLE_TASK: '{workatoEmbeddedDomain}/workflow_portals/current#settings',
  PROPERTIES: '{workatoEmbeddedDomain}/account_properties',
  PUB_SUB: '{workatoEmbeddedDomain}/topics',
  RECIPE_LIFECYCLE_MANAGEMENT: '{workatoEmbeddedDomain}/export_manifests',
  WORKBOT: '{workatoEmbeddedDomain}/workbots#active',
  ON_PREM_GROUP: '{workatoEmbeddedDomain}/on_prem_groups',
  VIEW_ALL_RECIPE: '{workatoEmbeddedDomain}/recipes?fid=smart-recipe',
  API_PLATFORM: '{workatoEmbeddedDomain}/api_management/dashboard',
};

export const WORKATO_CONFIG = {
  WORKATO_ACTIVATE_PAGE_VIDEO_URL: 'WORKATO_ACTIVATE_PAGE_VIDEO_URL',
  WORKATO_ENTER_PAGE_VIDEO_URL: 'WORKATO_ENTER_PAGE_VIDEO_URL',
  WORKATO_READ_DOCUMENTATION: 'WORKATO_READ_DOCUMENTATION',
  WORKATO_LEARN_MORE: 'WORKATO_LEARN_MORE',
  WORKATO_LEGAL_TERMS: 'WORKATO_LEGAL_TERMS',
  WORKATO_EMBEDDED_DOMAIN: 'WORKATO_EMBEDDED_DOMAIN',
};

export const MEDALLIA_CONFIG = {
  MEDALLIA_INITIALIZATION: 'MEDALLIA_INTIALIZATION',
  MEDALLIA_FETCH_SURVEYS: 'MEDALLIA_FETCH_SURVEYS',
  MEDALLIA_FETCH_SKILLS: 'MEDALLIA_FETCH_SKILLS',
  MEDALLIA_TEST_API_CONFIG: 'MEDALLIA_TEST_API_CONFIG',
  MEDALLIA_MAPPING_CONFIG: 'MEDALLIA_MAPPING_CONFIG',
  MEDALLIA_SAVE_CONFIG_TO_DB: 'MEDALLIA_SAVE_CONFIG_TO_DB',
  MEDALLIA_FETCH_ACCOUNT_INFO: 'MEDALLIA_FETCH_ACCOUNT_INFO',
  MEDALLIA_PATCH_CONFIG_TO_DB: 'MEDALLIA_PATCH_CONFIG_TO_DB',
  MEDALLIA_SET_SURVEY_SKILLS_TO_DB: 'MEDALLIA_SET_SURVEY_SKILLS_TO_DB',
  MEDALLIA_DEL_SURVEY_SKILL_FROM_DB: 'MEDALLIA_DEL_SURVEY_SKILL_FROM_DB',
  MEDALLIA_UPDATE_SKILL_INTERACTIVENESS: 'MEDALLIA_UPDATE_SKILL_INTERACTIVENESS',
  MEDALLIA_FETCH_SKILL_INTERACTIVENESS: 'MEDALLIA_UPDATE_FETCH_INTERACTIVENESS',
};

export const MEDALLIA_CONFIG_NAVIGATION_FIELDS = {
  ADD_CONNECTION: 'add_connection',
  ASSIGN_SKILLS: 'assign_skills',
};

export const WIDGET_VIEWS = {
  CASE: 'case',
  CASES: 'cases',
  CASE_COMMENT: 'case_comment',
  CASE_COMMENTS: 'case_comments',
  CUSTOMER: 'customer',
};

export const WIDGET_LAYOUTS = {
  DETAILS: 'details',
  EDIT: 'edit',
  HEADER: 'header',
  SEARCH: 'search',
  LIST: 'list',
};

export const WIDGET_CONNECTION_CONFIG_FIELDS = {
  AUTH_SERVER_URL: 'AUTH_SERVER_URL',
  CLIENT_ID: 'CLIENT_ID',
  PRIVATE_KEY: 'PRIVATE_KEY',
  PRIVATE_KEY_PASSWORD: 'PRIVATE_KEY_PASSWORD',
  SYSTEM_AUTHENTICATION: 'SYSTEM_AUTHENTICATION',
  USER_AUTHENTICATION: 'USER_AUTHENTICATION',
  USER_AUTHENTICATION_TEXT: 'USER_AUTHENTICATION_TEXT',
  SYSTEM_ACCOUNT: 'SYSTEM_ACCOUNT',
  INTEGRATION_NAME_SALESFORCE: 'SALESFORCE',
  RADIO_TYPE: {
    SystemAuthentication: 'SystemAuthentication',
    UserAuthentication: 'UserAuthentication',
  },
};

export const WIDGET_CUSTOMIZATION_FIELDS = {
  WIDGET_NAME: 'WIDGET_NAME',
  WIDGET_LABEL: 'WIDGET_LABEL',
  WIDGET_SIZE: 'WIDGET_SIZE',
  WIDGET_SKILLS: 'WIDGET_SKILLS',
};

export const WIDGET_CONFIGURATION_NAVIGATION_FIELDS = {
  MAP_FIELDS: 'map_fields',
  CUSTOMISE_LAYOUT: 'customise_layout',
  SYNC_CHAT_TRANSCRIPT: 'sync_chat_transcript',
  CUSTOMER: 'customer',
  CASE: 'case',
  CASE_COMMENT: 'case_comment',
};

export const WIDGET_VIEW_CUSTOMER_DEFAULT_REQUEST_BODY = {
  name: 'Customer',
  entity: 'Account',
  fields: [
    'Id',
    'FirstName',
    'LastName',
    'Email',
    'Phone',
    'MobilePhone',
    'MailingStreet',
    'MailingCity',
    'MailingState',
    'MailingPostalCode',
  ],
  primaryKey: 'Id',
  description: 'The data view that represents a brand\'s customer',
};

export const WIDGET_VIEW_CASES_DEFAULT_REQUEST_BODY = {
  "entity": "Contact",
  "primaryKey": "Id",
  "fields": [
      "Id"
  ],
  "joins": [
      {
          "id": "Cases",
          "entity": "Case",
          "primaryKey": "Id",
          "leftKey": "Id",
          "rightKey": "ContactId",
          "relationship": "MANY",
          "fields": [
              "Id",
              "CaseNumber",
              "Subject"
          ]
      }
  ],
  "name": "Cases",
  "description": "The data view that represents a list of customer cases.",
  "id": "cases"
}

export const WIDGET_VIEW_CASE_DEFAULT_REQUEST_BODY = {
  name: 'Case',
  joins: [
    {
      id: 'Customer',
      entity: 'Contact',
      fields: [
        'Id',
      ],
      leftKey: 'ContactId',
      rightKey: 'Id',
      primaryKey: 'Id',
      relationship: 'ONE',
    },
  ],
  entity: 'Case',
  fields: [
    'CaseNumber',
    'Subject',
    'Description',
    'Origin',
    'Status',
    'Priority',
    'CreatedDate',
    'UpdatedDate',
    'GlobalReason',
  ],
  primaryKey: 'Id',
  description: 'The data view that represents a customer case.',
};

export const WIDGET_VIEW_CASE_COMMENT_DEFAULT_REQUEST_BODY = {
  name: 'Case Comment',
  joins: [
    {
      id: 'case',
      entity: 'Case',
      fields: [
        'Id',
      ],
      leftKey: 'ParentId',
      rightKey: 'Id',
      primaryKey: 'Id',
      relationship: 'ONE',
    },
  ],
  entity: 'CaseComment',
  fields: [
    'Id',
    'CommentBody',
    'CreatorName',
    'CreatedDate',
  ],
  primaryKey: 'Id',
  description: 'The data view that represents a case comment',
};

export const WIDGET_LAYOUT_CASE_DETAILS_DEFAULT_REQUEST_BODY = {
  name: 'Case Details',
  fields: [
    {
      name: 'Origin',
      type: 'SELECT',
      label: 'Case origin',
      required: true,
    },
    {
      name: 'CreatedDate',
      type: 'INPUT',
      label: 'Date created',
      format: 'DATETIME',
      required: true,
    },
    {
      name: 'Status',
      type: 'SELECT',
      label: 'Status',
      required: true,
    },
    {
      name: 'Priority',
      type: 'SELECT',
      label: 'Priority',
      required: true,
    },
    {
      name: 'Subject',
      type: 'INPUT',
      label: 'Subject',
      required: true,
    },
    {
      name: 'Description',
      type: 'TEXT',
      label: 'Description',
      required: false,
    },
  ],
  description: 'A layout of the case details.',
  transitions: [
    {
      view: 'case',
      label: 'Edit case details',
      layout: 'edit',
      actions: [
        'READ',
      ],
    },
    {
      view: 'case',
      label: 'Sync transcript',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CASE_EDIT_DEFAULT_REQUEST_BODY = {
  name: 'Edit Case Details',
  fields: [
    {
      name: 'Origin',
      type: 'SELECT',
      label: 'Case origin',
      required: true,
    },
    {
      name: 'Status',
      type: 'SELECT',
      label: 'Status',
      required: true,
    },
    {
      name: 'Priority',
      type: 'SELECT',
      label: 'Priority',
      required: true,
    },
    {
      name: 'Subject',
      type: 'INPUT',
      label: 'Subject',
      required: true,
    },
    {
      name: 'Description',
      type: 'TEXT',
      label: 'Description',
      required: false,
    },
  ],
  description: 'A layout of the edit case details form.',
  transitions: [
    {
      view: 'case',
      label: 'Confirm changes',
      layout: 'details',
      actions: [
        'CREATE',
        'UPDATE',
        'READ',
      ],
    },
    {
      view: 'case',
      label: 'Cancel',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CASE_HEADER_DEFAULT_REQUEST_BODY = {
  name: 'Case Header',
  fields: [
    {
      name: 'CaseNumber',
      type: 'INPUT',
      label: 'Case ID',
      required: true,
    },
    {
      name: 'Subject',
      type: 'INPUT',
      label: 'Subject',
      required: true,
    },
  ],
  description: 'A layout of the case header in the list of all cases',
  transitions: [
    {
      view: 'case',
      label: 'Details',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CASE_SEARCH_DEFAULT_REQUEST_BODY = {
  name: 'Search Result',
  fields: [
    {
      name: 'customer.FirstName',
      type: 'INPUT',
      label: 'First Name',
      required: true,
    },
    {
      name: 'customer.LastName',
      type: 'INPUT',
      label: 'Last Name',
      required: true,
    },
    {
      name: 'CaseNumber',
      type: 'INPUT',
      label: 'Case no',
      required: true,
    },
  ],
  description: 'A layout of the case record in the search result',
  transitions: [
    {
      view: 'case',
      label: 'Details',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CASE_COMMENT_DETAILS_DEFAULT_REQUEST_BODY = {
  name: 'Case Comment Details',
  description: 'A layout of the add case comment form.',
  fields: [
    {
      type: 'TEXT',
      name: 'CommentBody',
      label: 'Comment',
      required: true,
    },
    {
      type: 'OBJECT',
      name: 'CreatedBy',
      label: 'By',
      fields: [
        {
          type: 'INPUT',
          name: 'Name',
          label: 'Name',
          required: false,
        },
      ],
    },
    {
      type: 'INPUT',
      name: 'CreatedDate',
      label: 'Date created',
      required: true,
    },
  ],
  transitions: [
    {
      label: 'Confirm changes',
      view: 'case_comments',
      layout: 'list',
      actions: [
        'CREATE',
        'READ',
      ],
    },
    {
      label: 'Cancel',
      view: 'case_comments',
      layout: 'list',
      actions: [
        'READ',
      ],
    },
  ],
  id: 'details',
};

export const WIDGET_LAYOUT_CASE_COMMENT_EDIT_DEFAULT_REQUEST_BODY = {
  name: 'Edit Case Comment',
  description: 'A layout of the add case comment form.',
  fields: [
    {
      type: 'TEXT',
      name: 'CommentBody',
      label: 'Comment',
      required: true,
    },
  ],
  transitions: [
    {
      label: 'Confirm changes',
      view: 'case_comments',
      layout: 'list',
      actions: [
        'CREATE',
        'READ',
      ],
    },
    {
      label: 'Cancel',
      view: 'case_comments',
      layout: 'list',
      actions: [
        'READ',
      ],
    },
  ],
  id: 'edit',
};

export const WIDGET_LAYOUT_CASE_COMMENTS_LIST_DEFAULT_REQUEST_BODY = {
  name: 'Case Comments List',
  description: 'A layout of the list of case comments.',
  fields: [
    {
      type: 'OBJECT',
      name: 'Comments',
      label: 'Comments',
      fields: [
        {
          type: 'TEXT',
          name: 'CommentBody',
          label: 'Comment',
          required: true,
        },
        {
          type: 'OBJECT',
          name: 'CreatedBy',
          label: 'By',
          fields: [
            {
              type: 'INPUT',
              name: 'Name',
              label: 'Name',
              required: false,
            },
          ],
        },
        {
          type: 'INPUT',
          name: 'CreatedDate',
          label: 'On',
          required: false,
          format: 'DATETIME',
        },
      ],
    },
  ],
  transitions: [
    {
      label: 'Add new comment',
      view: 'case_comment',
      layout: 'edit',
    },
  ],
  id: 'list',
};

export const WIDGET_LAYOUT_CUSTOMER_DETAILS_DEFAULT_REQUEST_BODY = {
  name: 'Contact Info',
  fields: [
    {
      name: 'FirstName',
      type: 'INPUT',
      label: 'First Name',
      required: true,
    },
    {
      name: 'LastName',
      type: 'INPUT',
      label: 'Last Name',
      required: true,
    },
    {
      name: 'Email',
      type: 'INPUT',
      label: 'Email',
      format: 'EMAIL',
      required: true,
    },
    {
      name: 'Phone',
      type: 'INPUT',
      label: 'Primary Phone',
      format: 'PHONE',
      required: true,
    },
    {
      name: 'MobilePhone',
      type: 'INPUT',
      label: 'Mobile Phone',
      format: 'PHONE',
      required: false,
    },
    {
      name: 'MailingStreet',
      type: 'INPUT',
      label: 'Mailing Street',
      required: false,
    },
    {
      name: 'MailingCity',
      type: 'INPUT',
      label: 'Mailing City',
      required: false,
    },
    {
      name: 'MailingState',
      type: 'SELECT',
      label: 'Mailing State',
      required: false,
    },
    {
      name: 'MailingPostalCode',
      type: 'INPUT',
      label: 'Zip Code',
      required: false,
    },
  ],
  description: 'A layout of the customer contact information tab',
  transitions: [
    {
      view: 'customer',
      label: 'Edit contact details',
      layout: 'edit',
      actions: [
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CUSTOMER_EDIT_DEFAULT_REQUEST_BODY = {
  name: 'Edit Contact Details',
  fields: [
    {
      name: 'FirstName',
      type: 'INPUT',
      label: 'First Name',
      required: true,
    },
    {
      name: 'LastName',
      type: 'INPUT',
      label: 'Last Name',
      required: true,
    },
    {
      name: 'Email',
      type: 'INPUT',
      label: 'Email',
      format: 'EMAIL',
      required: true,
    },
    {
      name: 'Phone',
      type: 'INPUT',
      label: 'Primary Phone',
      format: 'PHONE',
      required: true,
    },
    {
      name: 'MobilePhone',
      type: 'INPUT',
      label: 'Mobile Phone',
      format: 'PHONE',
      required: false,
    },
    {
      name: 'MailingStreet',
      type: 'INPUT',
      label: 'Mailing Street',
      required: false,
    },
    {
      name: 'MailingCity',
      type: 'INPUT',
      label: 'Mailing City',
      required: false,
    },
    {
      name: 'MailingState',
      type: 'SELECT',
      label: 'Mailing State',
      required: false,
    },
    {
      name: 'MailingPostalCode',
      type: 'INPUT',
      label: 'Zip Code',
      required: false,
    },
  ],
  description: 'A layout of the edit customer contact details form',
  transitions: [
    {
      view: 'customer',
      label: 'Cancel',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
    {
      view: 'customer',
      label: 'Confirm changes',
      layout: 'details',
      actions: [
        'UPDATE',
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CUSTOMER_HEADER_DEFAULT_REQUEST_BODY = {
  name: 'Customer Profile Header',
  fields: [
    {
      name: 'FirstName',
      type: 'INPUT',
      label: 'First Name',
      required: true,
    },
    {
      name: 'LastName',
      type: 'INPUT',
      label: 'Last Name',
      required: true,
    },
  ],
  description: 'A layout of the customer profile header',
  transitions: [
    {
      view: 'customer',
      label: 'Contact Info',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
    {
      view: 'case',
      label: 'All Cases',
      layout: 'header',
      actions: [
        'READ',
      ],
    },
  ],
};

export const WIDGET_LAYOUT_CUSTOMER_SEARCH_DEFAULT_REQUEST_BODY = {
  name: 'Search Result',
  fields: [
    {
      name: 'FirstName',
      type: 'INPUT',
      label: 'First Name',
      required: true,
    },
    {
      name: 'LastName',
      type: 'INPUT',
      label: 'Last Name',
      required: true,
    },
    {
      name: 'PersonEmail',
      type: 'INPUT',
      label: 'Email ID',
      format: 'EMAIL',
      required: true,
    },
    {
      name: 'Phone',
      type: 'INPUT',
      label: 'Phone no',
      format: 'PHONE',
      required: true,
    },
  ],
  description: 'A layout of the customer record in the search result',
  transitions: [
    {
      view: 'customer',
      label: 'Details',
      layout: 'details',
      actions: [
        'READ',
      ],
    },
  ],
};

export const HTTP_STATUS_CODE = {
  /**
   * The server has received the request headers and the client should proceed to send the request body
   * (in the case of a request for which a body needs to be sent; for example, a POST request).
   * Sending a large request body to a server after a request has been rejected for inappropriate headers would be inefficient.
   * To have a server check the request's headers, a client must send Expect: 100-continue as a header in its initial request
   * and receive a 100 Continue status code in response before sending the body. The response 417 Expectation Failed indicates the request should not be continued.
   */

  CONTINUE: 100,

  /**
     * The requester has asked the server to switch protocols and the server has agreed to do so.
     */
  SWITCHING_PROTOCOLS: 101,

  /**
     * A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request.
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     * This prevents the client from timing out and assuming the request was lost.
     */
  PROCESSING: 102,

  /**
     * Standard response for successful HTTP requests.
     * The actual response will depend on the request method used.
     * In a GET request, the response will contain an entity corresponding to the requested resource.
     * In a POST request, the response will contain an entity describing or containing the result of the action.
     */
  OK: 200,

  /**
     * The request has been fulfilled, resulting in the creation of a new resource.
     */
  CREATED: 201,

  /**
     * The request has been accepted for processing, but the processing has not been completed.
     * The request might or might not be eventually acted upon, and may be disallowed when processing occurs.
     */
  ACCEPTED: 202,

  /**
     * SINCE HTTP/1.1
     * The server is a transforming proxy that received a 200 OK from its origin,
     * but is returning a modified version of the origin's response.
     */
  NON_AUTHORITATIVE_INFORMATION: 203,

  /**
     * The server successfully processed the request and is not returning any content.
     */
  NO_CONTENT: 204,

  /**
     * The server successfully processed the request, but is not returning any content.
     * Unlike a 204 response, this response requires that the requester reset the document view.
     */
  RESET_CONTENT: 205,

  /**
     * The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
     * The range header is used by HTTP clients to enable resuming of interrupted downloads,
     * or split a download into multiple simultaneous streams.
     */
  PARTIAL_CONTENT: 206,

  /**
     * The message body that follows is an XML message and can contain a number of separate response codes,
     * depending on how many sub-requests were made.
     */
  MULTI_STATUS: 207,

  /**
     * The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response,
     * and are not being included again.
     */
  ALREADY_REPORTED: 208,

  /**
     * The server has fulfilled a request for the resource,
     * and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
     */
  IM_USED: 226,

  /**
     * Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
     * For example, this code could be used to present multiple video format options,
     * to list files with different filename extensions, or to suggest word-sense disambiguation.
     */
  MULTIPLE_CHOICES: 300,

  /**
     * This and all future requests should be directed to the given URI.
     */
  MOVED_PERMANENTLY: 301,

  /**
     * This is an example of industry practice contradicting the standard.
     * The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
     * (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
     * with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
     * to distinguish between the two behaviours. However, some Web applications and frameworks
     * use the 302 status code as if it were the 303.
     */
  FOUND: 302,

  /**
     * SINCE HTTP/1.1
     * The response to the request can be found under another URI using a GET method.
     * When received in response to a POST (or PUT/DELETE), the client should presume that
     * the server has received the data and should issue a redirect with a separate GET message.
     */
  SEE_OTHER: 303,

  /**
     * Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
     * In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
     */
  NOT_MODIFIED: 304,

  /**
     * SINCE HTTP/1.1
     * The requested resource is available only through a proxy, the address for which is provided in the response.
     * Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
     */
  USE_PROXY: 305,

  /**
     * No longer used. Originally meant "Subsequent requests should use the specified proxy."
     */
  SWITCH_PROXY: 306,

  /**
     * SINCE HTTP/1.1
     * In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
     * In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
     * For example, a POST request should be repeated using another POST request.
     */
  TEMPORARY_REDIRECT: 307,

  /**
     * The request and all future requests should be repeated using another URI.
     * 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
     * So, for example, submitting a form to a permanently redirected resource may continue smoothly.
     */
  PERMANENT_REDIRECT: 308,

  /**
     * The server cannot or will not process the request due to an apparent client error
     * (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
     */
  BAD_REQUEST: 400,

  /**
     * Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
     * been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
     * requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
     * "unauthenticated",i.e. the user does not have the necessary credentials.
     */
  UNAUTHORIZED: 401,

  /**
     * Reserved for future use. The original intention was that this code might be used as part of some form of digital
     * cash or micro payment scheme, but that has not happened, and this code is not usually used.
     * Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
     */
  PAYMENT_REQUIRED: 402,

  /**
     * The request was valid, but the server is refusing action.
     * The user might not have the necessary permissions for a resource.
     */
  FORBIDDEN: 403,

  /**
     * The requested resource could not be found but may be available in the future.
     * Subsequent requests by the client are permissible.
     */
  NOT_FOUND: 404,

  /**
     * A request method is not supported for the requested resource;
     * for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
     */
  METHOD_NOT_ALLOWED: 405,

  /**
     * The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
     */
  NOT_ACCEPTABLE: 406,

  /**
     * The client must first authenticate itself with the proxy.
     */
  PROXY_AUTHENTICATION_REQUIRED: 407,

  /**
     * The server timed out waiting for the request.
     * According to HTTP specifications:
     * "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
     */
  REQUEST_TIMEOUT: 408,

  /**
     * Indicates that the request could not be processed because of conflict in the request,
     * such as an edit conflict between multiple simultaneous updates.
     */
  CONFLICT: 409,

  /**
     * Indicates that the resource requested is no longer available and will not be available again.
     * This should be used when a resource has been intentionally removed and the resource should be purged.
     * Upon receiving a 410 status code, the client should not request the resource in the future.
     * Clients such as search engines should remove the resource from their indices.
     * Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
     */
  GONE: 410,

  /**
     * The request did not specify the length of its content, which is required by the requested resource.
     */
  LENGTH_REQUIRED: 411,

  /**
     * The server does not meet one of the preconditions that the requester put on the request.
     */
  PRECONDITION_FAILED: 412,

  /**
     * The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
     */
  PAYLOAD_TOO_LARGE: 413,

  /**
     * The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
     * in which case it should be converted to a POST request.
     * Called "Request-URI Too Long" previously.
     */
  URI_TOO_LONG: 414,

  /**
     * The request entity has a media type which the server or resource does not support.
     * For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
     */
  UNSUPPORTED_MEDIA_TYPE: 415,

  /**
     * The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
     * For example, if the client asked for a part of the file that lies beyond the end of the file.
     * Called "Requested Range Not Satisfiable" previously.
     */
  RANGE_NOT_SATISFIABLE: 416,

  /**
     * The server cannot meet the requirements of the Expect request-header field.
     */
  EXPECTATION_FAILED: 417,

  /**
     * This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
     * and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
     * teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
     */
  I_AM_A_TEAPOT: 418,

  /**
     * The request was directed at a server that is not able to produce a response (for example because a connection reuse).
     */
  MISDIRECTED_REQUEST: 421,

  /**
     * The request was well-formed but was unable to be followed due to semantic errors.
     */
  UNPROCESSABLE_ENTITY: 422,

  /**
     * The resource that is being accessed is locked.
     */
  LOCKED: 423,

  /**
     * The request failed due to failure of a previous request (e.g., a PROPPATCH).
     */
  FAILED_DEPENDENCY: 424,

  /**
     * The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
     */
  UPGRADE_REQUIRED: 426,

  /**
     * The origin server requires the request to be conditional.
     * Intended to prevent "the 'lost update' problem, where a client
     * GETs a resource's state, modifies it, and PUTs it back to the server,
     * when meanwhile a third party has modified the state on the server, leading to a conflict."
     */
  PRECONDITION_REQUIRED: 428,

  /**
     * The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
     */
  TOO_MANY_REQUESTS: 429,

  /**
     * The server is unwilling to process the request because either an individual header field,
     * or all the header fields collectively, are too large.
     */
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,

  /**
     * A server operator has received a legal demand to deny access to a resource or to a set of resources
     * that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
     */
  UNAVAILABLE_FOR_LEGAL_REASONS: 451,

  /**
     * A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
     */
  INTERNAL_SERVER_ERROR: 500,

  /**
     * The server either does not recognize the request method, or it lacks the ability to fulfill the request.
     * Usually this implies future availability (e.g., a new feature of a web-service API).
     */
  NOT_IMPLEMENTED: 501,

  /**
     * The server was acting as a gateway or proxy and received an invalid response from the upstream server.
     */
  BAD_GATEWAY: 502,

  /**
     * The server is currently unavailable (because it is overloaded or down for maintenance).
     * Generally, this is a temporary state.
     */
  SERVICE_UNAVAILABLE: 503,

  /**
     * The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
     */
  GATEWAY_TIMEOUT: 504,

  /**
     * The server does not support the HTTP protocol version used in the request
     */
  HTTP_VERSION_NOT_SUPPORTED: 505,

  /**
     * Transparent content negotiation for the request results in a circular reference.
     */
  VARIANT_ALSO_NEGOTIATES: 506,

  /**
     * The server is unable to store the representation needed to complete the request.
     */
  INSUFFICIENT_STORAGE: 507,

  /**
     * The server detected an infinite loop while processing the request.
     */
  LOOP_DETECTED: 508,

  /**
     * Further extensions to the request are required for the server to fulfill it.
     */
  NOT_EXTENDED: 510,

  /**
     * The client needs to authenticate to gain network access.
     * Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
     * to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
     */
  NETWORK_AUTHENTICATION_REQUIRED: 511,
};

export const SALESFORCE_WIZARD_PENDO_TRACK_NAME = 'Integration Hub | Salesforce Wizard';

